import anne from '@videos/anne.mp4';

// al-khalili story, section 2: an animation plays over the photo while hovered
// (styles in _specific.scss). Loaded on first hover only.
export default function hoverVideo() {
    const figure = document.querySelector('.al-khalili .section-2 figure');
    if (!figure) return;

    const video = Object.assign(document.createElement('video'), {
        src: anne, muted: true, loop: true, playsInline: true, preload: 'none',
    });
    video.setAttribute('aria-hidden', 'true');
    figure.append(video);

    figure.addEventListener('mouseenter', () => video.play().catch(() => {}));
    figure.addEventListener('mouseleave', () => video.pause());
}
